import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
         {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
         ]
        },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone Number:*',
           mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Type:*',
              options: [
                { label: 'Corporate Events & Meetings', value: 'Corporate Events & Meetings' },
                { label: 'Receptions/Luncheons/Other', value: 'Receptions/Luncheons/Other' },
                { label: 'Birthday Parties/Baby Showers', value: 'Birthday Parties/Baby Showers' },
                { label: 'Weddings and Wedding Receptions', value: 'Weddings and Wedding Receptions' },
              ],
              mapping: 'theme'
            }
          ]
        },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Venue Preference:*',
                options: [
                  { label: 'Teton Trek', value: 'Teton Trek' },
                  { label: 'Zambezi Rondavel', value: 'Zambezi Rondavel' },
                  { label: 'Northwest Passage', value: 'Northwest Passage' },
                  { label: 'Primate Pavilion', value: 'Primate Pavilion' },
                  { label: 'China Theater', value: 'China Theater' },
                  { label: 'Farm Expo Building', value: 'Farm Expo Building' },
                  { label: 'Monogram Foods Loves Kids Foundation Splash Park', value: 'Monogram Foods Loves Kids Foundation Splash Park' },
                  { label: 'Cat House Cafe', value: 'Cat House Cafe' },
                  { label: 'Zoo Buyout', value: 'Zoo Buyout' },
                ],
                mapping: 'sitename'
              }
            ]
          },
          {
            fields: [
              {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Budget:*',
              options: [
                { label: '$1200-$3500', value: '$1200-$3500' },
                { label: '$3500-$10,000', value: '$3500-$10,000' },
                { label: '$10,000+', value: '$10,000+' },
              ],
              mapping: 'category'
            }
          ]
        },
          {
            fields: [
              {
                type: 'text-area',
                size: 'XLarge',
                label: 'Additional Comments:',
                mapping: 'notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Memphis Zoo Contact Form',
    formId: '2122',
    clientKey: '78607606-3198-4B4B-A508-2B7047E747D3',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your inquiry. We will reach to you within 24 business hours. Thank you!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
